import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
// Local files
import { confirmationsActions } from 'features/confirmations';

const useConfirmations = () => {
  const dispatch = useDispatch();
  const sendConfirmationCode = useCallback(({ email, password }) => dispatch(confirmationsActions.sendConfirmationCode({ email, password })), [dispatch]);

  return { sendConfirmationCode };
};

export default useConfirmations;